let cacheMemory = {};
const CACHE_NAME = 'app-cache-storage';

export const cacheStorage = {
    getItem: (key) => cacheMemory[key] || null,
    
    setItem: async (key, value) => {
        cacheMemory[key] = value;
        try {
            const cache = await caches.open(CACHE_NAME);
            const response = new Response(value);
            await cache.put(`/${key}`, response);
        } catch (error) {
            console.error('Error setting cache item:', error);
        }
    },
    
    removeItem: async (key) => {
        delete cacheMemory[key];
        try {
            const cache = await caches.open(CACHE_NAME);
            await cache.delete(`/${key}`);
        } catch (error) {
            console.error('Error removing cache item:', error);
        }
    },
    
    init: async () => {
        try {
            const cache = await caches.open(CACHE_NAME);
            const requests = await cache.keys();
            for (let req of requests) {
                const url = new URL(req.url);
                const key = url.pathname.substring(1);
                const res = await cache.match(req);
                if (res) {
                    cacheMemory[key] = await res.text();
                }
            }
        } catch (error) {
            console.error('Error initializing cache storage:', error);
        }
    }
};

export default cacheStorage;